import React from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, DialogActions, Button, Chip, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const MaterialDetailsDialog = ({ openMaterialDialog, handleCloseMaterialsDetails, selectedMaterial }) => {
    return (
        <Dialog open={openMaterialDialog} onClose={handleCloseMaterialsDetails}>
            {selectedMaterial && (
                <>
                    <DialogTitle>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <span>{selectedMaterial?.fields?.ID || 'Onbekend'}</span>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {selectedMaterial?.fields?.Status && (
                                    <Chip
                                        label={selectedMaterial.fields.Status}
                                        size="small"
                                        color="error"
                                    />
                                )}
                                <IconButton
                                    aria-label="close"
                                    onClick={handleCloseMaterialsDetails}
                                    size="small"
                                    sx={{ color: 'grey.500' }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </div>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant="h6">{selectedMaterial?.fields?.Categorie || 'Onbekend'}</Typography>
                        <Typography variant="body1">Omschrijving: {selectedMaterial?.fields?.Omschrijving || 'Geen omschrijving'}</Typography>
                        {selectedMaterial?.fields?.Afbeelding && selectedMaterial.fields.Afbeelding[0] && (
                            <img src={selectedMaterial.fields.Afbeelding[0].url} alt="Material" style={{ maxWidth: '100%', marginTop: '10px' }} />
                        )}
                    </DialogContent>
                </>
            )}
            <DialogActions>
                <Button onClick={handleCloseMaterialsDetails} color="primary">Sluiten</Button>
            </DialogActions>
        </Dialog>
    );
};

export default MaterialDetailsDialog;
